import ShareWidget from './share-widget.component';
import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import { connect } from 'react-redux';
import { SHARE_TRACKING } from '@medscape-promo/medscapetv/omniture-tracking';
const { mmodule, mlink } = SHARE_TRACKING;

const mapStateToProps = (state, ownProps) => {
    return ownProps;
};

const mapDispatchToProps = dispatch => {
    return {
        onTwitterClick: () => {
            dispatch(WebViewActions.omnitureTracking(`${mmodule}_${mlink.twitter}`));
        },
        onFacebookClick: () => {
            dispatch(WebViewActions.omnitureTracking(`${mmodule}_${mlink.facebook}`));
        },
        onLinkedInClick: () => {
            dispatch(WebViewActions.omnitureTracking(`${mmodule}_${mlink.linkedin}`));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareWidget);


